import HiringTeamSuccessBanner from './HiringTeamSuccessBanner';

export default HiringTeamSuccessBanner;
